module.exports = __webpack_public_path__ + "static/PlutoSansBold-d70b193c06383d3d7a6a2c55276662b5.woff";